/**
 * Invoca internal copy to clipboard plugin inspired by clippy
 */
import $ from "jquery";

$.fn.clippy = function(config) {
  config = config || {};

  var useIcons    = config.useIcons;
  var clippyId    = new Date().getTime();
  var containerId = "clippy-container--" + clippyId;
  var target      = $(this);
  var parent      = $('<span id="' + containerId + '"></span>');

  if (document.execCommand) {
    var readyText = useIcons ? "&#128203" : "Copy to clipboard";
    var successText =  useIcons ? "&#9989" : "Copied!";
    var copyBtn = $('<span class="ui-copy-to-clipboard" title="Copy to clipboard">' + readyText + '</span>');

    target.replaceWith(parent);
    parent.append(target).append(copyBtn);

    copyBtn.on('click', function() {
      target.select();
      document.execCommand('copy');

      copyBtn.html(successText);
      setTimeout(function() {
        copyBtn.html(readyText);
      }, 1000);
    });
  }

  return this;
};
